import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';

const LastFetchData = () => {
  const { lastUpdated } = useSelector((state: RootState) => state.cases);

  return (
    <div className="flex items-center gap-1 text-white">
      <div className="font-medium">Sidste opdatering | {lastUpdated}</div>
    </div>
  );
};

export default LastFetchData;
